import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCombobox } from 'downshift';
import { useEffect, useState } from 'react';
import styles from './Typeahead.module.less';
const sizes = ['default', 'large'];
const Typeahead = (props) => {
    const { defaultOpen = false, initialSelectedItem, isLabelHidden = false, label = '', onChange, placeholder, size = 'default', options = [], value } = props;
    const errorStyles = {};
    let finalSize = size;
    const [inputItems, setInputItems] = useState(options);
    const { getComboboxProps, getInputProps, getItemProps, getLabelProps, getMenuProps, getToggleButtonProps, highlightedIndex, isOpen, openMenu, setInputValue } = useCombobox({
        initialIsOpen: defaultOpen,
        initialSelectedItem: initialSelectedItem,
        items: inputItems,
        itemToString: item => (item ? item[1] : ''),
        onInputValueChange: ({ inputValue }) => {
            setInputItems(options.filter(item => {
                if (inputValue !== undefined) {
                    return item[1]
                        .toLowerCase()
                        .includes(inputValue.toLowerCase());
                }
            }));
        },
        onSelectedItemChange: onChange || undefined
    });
    if (!sizes.includes(size)) {
        console.warn('Invalid size passed - using default size');
        finalSize = 'default';
    }
    useEffect(() => {
        setInputItems(options);
    }, [isOpen]);
    useEffect(() => {
        if (!value) {
            setInputValue('');
        }
        else {
            const selectedOption = options.find(option => option[0] === value.toString());
            setInputValue(selectedOption ? selectedOption[1] : options[0][1]);
        }
    }, [value]);
    return (_jsxs("div", { className: styles['hvui-typeahead'], children: [label && (_jsx("div", { className: isLabelHidden
                    ? 'visually-hidden'
                    : 'ant-form-item-label', children: _jsx("label", { style: errorStyles, ...getLabelProps(), children: label }) })), _jsxs("div", { ...getComboboxProps(), id: "typeahead-combobox", className: [
                    styles['typeahead-wrapper'],
                    styles[`${finalSize !== 'default' ? 'lg' : ''}`]
                ].join(' '), children: [_jsx("input", { ...getInputProps({
                            onFocus: () => {
                                if (!isOpen) {
                                    openMenu();
                                }
                            }
                        }), placeholder: placeholder }), _jsx("button", { type: "button", ...getToggleButtonProps(), children: _jsx("span", { className: "visually-hidden", children: "toggle menu" }) })] }), _jsx("ul", { ...getMenuProps(), id: "typeahead-options", children: isOpen && (_jsx(_Fragment, { children: inputItems.length ? (inputItems.map((item, index) => (_jsx("li", { ...getItemProps({ item, index }), style: highlightedIndex === index
                            ? {
                                backgroundColor: 'var(--gray900)'
                            }
                            : {}, children: item[1] }, `${item[0]}${index}`)))) : (_jsx("li", { children: "No options found." })) })) })] }));
};
export default Typeahead;
